module.exports = "<div class=\"progress-bar\"\r\nstyle=\"min-width: 0;\"\r\nrole=\"progressbar\"\r\n[ngClass]=\"type && 'progress-bar-' + type\"\r\n[ngStyle]=\"{width: (percent < 100 ? percent : 100) + '%', transition: transition}\"\r\naria-valuemin=\"0\"\r\n[attr.aria-valuenow]=\"value\"\r\n[attr.aria-valuetext]=\"percent.toFixed(0) + '%'\"\r\n[attr.aria-valuemax]=\"max\">\r\n  <ng-content></ng-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/progressbars/bar.component.html
// module id = ../../../../../src/libs/mdbootstrap/typescripts/pro/progressbars/bar.component.html
// module chunks = main